import React, {Component, ReactElement} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {ContentsSubTitleInner, ContentsSubTitleWrapper, MainContainer} from '../../../styledComponents/ContentsArea'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {generateMedia} from 'styled-media-query'
import {BreakPoint, Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import PreformattedDiv from '../../../styledComponents/PreformattedDiv'
import {Box} from '@mui/material'
import {NatAsyncCallFunction} from '../../common/util/Natutil'
import NatCommunicationPlatformRepo from './repository/NatCommunicationPlatformRepo'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {PrimaryStyledButton} from '../../../styledComponents/Button'
import {NatPostCommunicationPlatform} from './repository/NatPostCommunicationPlatform'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {RequestItemError} from '../../../network/response/RequestItemError'
import {Location} from 'react-router-dom'

interface Props {
    communicationPlatformRepo: NatCommunicationPlatformRepo,
    currentDateTimeRepo: NatCurrentDateTimeRepo,
    location: Location
}


interface States {
    isLoadCompleted: boolean,
    isRegistrationCompleted: boolean,
    registrationErrorMessage: string
}

class NatResidentCommunicationPlatformRegisterPage extends Component<Props & ResidentPagePropsSet, States> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            isLoadCompleted: false,
            isRegistrationCompleted: false,
            registrationErrorMessage: '',
        }

        this.clickMypageButtonClick = this.clickMypageButtonClick.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {

            // 現在日時取得
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await NatAsyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(
                    this.props.currentDateTimeRepo), this.props.navigate)

            // コミュニケーションプラットフォーム利用登録処理
            const communicationPlatformResponse: Nullable<NatPostCommunicationPlatform> =
                await NatAsyncCallFunction(
                    this.props.communicationPlatformRepo.postCommunicationPlatform.bind(
                        this.props.communicationPlatformRepo), this.props.navigate)

            this.setState({isRegistrationCompleted: true})

        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                errorResponseBody.requestItemErrors.forEach((item: RequestItemError) => {
                    if (item.fields) {
                        this.setState({registrationErrorMessage: item.message})
                    }
                })
            }

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    // マイページへ
    clickMypageButtonClick(): void {
        this.props.navigate(`/resident/mypage`)
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return (
                <>
                    <ContentsSubTitleWrapper>
                        <ContentsSubTitleInner>
                            <TitleText></TitleText>
                        </ContentsSubTitleInner>
                    </ContentsSubTitleWrapper>
                    素敵ネットユーザ情報を、コミュニケーションプラットフォームへ登録中です。
                </>
            )
        }

        return (
            <>
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        <TitleText></TitleText>
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                {(this.state.isRegistrationCompleted) ?
                    <InitialMessage>
                        コミュニケーションプラットフォーム利用登録が完了しました。
                    </InitialMessage> : <></>
                }

                <MainContainer>
                    <ErrorMessage>
                        {(this.state.registrationErrorMessage) ?
                            this.state.registrationErrorMessage : <></>
                        }
                    </ErrorMessage>
                    <Box padding={'15px 0 15px 0'}>
                        <PrimaryStyledButton
                            onClick={this.clickMypageButtonClick}
                            disabled={false}>
                            マイページへ
                        </PrimaryStyledButton>
                    </Box>
                </MainContainer>
            </>
        )
    }
}

export default createResidentPage(NatResidentCommunicationPlatformRegisterPage)

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})


export const ErrorMessage = styled(PreformattedDiv)`
  color: ${Colors.Alert};
  font-weight: ${FontWeights.Bold};
  font-size: ${FontSize.Body};
  padding: 10px 0;
`

export const InitialMessage = styled(PreformattedDiv)`
  background-color: rgb(0, 131, 138);
  color: white;
  font-weight: ${FontWeights.Bold};
  font-size: ${FontSize.Body};
  padding: 10px;
`

const TitleText: StyledDiv = styled.div`
  &::before {
    content: "コミュニケーションプラットフォーム利用登録";
  }

  ${breakPoint.lessThan('sp')`

  &::before {
    white-space: pre;
    content: "ｺﾐｭﾆｹｰｼｮﾝﾌﾟﾗｯﾄﾌｫｰﾑ\\A利用登録";
  }
  `}
`
